import { useGetAccountInfo } from '@/lib/api/account'

export type UseAccountTimezoneResult = {
  timezone: string
  isReady: boolean
}

export const useAccountTimezone = (): UseAccountTimezoneResult => {
  const { data, isSuccess } = useGetAccountInfo()
  return {
    timezone: data?.timezone ?? 'UTC',
    isReady: isSuccess,
  }
}
